// React
import React from 'react';
import AWS from 'aws-sdk';
// External
import moment from 'moment';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';
import invoiceService from 'services/invoices';
import config from 'config/config';
// Styles
import './styles.scss';

class Accounts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoiceList: []
        };
        this.headers = Object.freeze([
            {
                name: 'id',
                id: 'id',
            },
            {
                name: 'date',
                id: 'date',
            },
            {
                name: 'type',
                id: 'type',
            },
            {
                name: 'status',
                id: 'status',
            },
            {
                name: 'amount',
                id: 'amount',
            },
            {
                name: 'Action',
                id: 'action',
            },
        ]);
    }

    componentDidMount() {
        this.getTokenFromS3();
    }

    getTokenFromS3 = () => {
        invoiceService.getInvoices()
            .then((response) => {
                this.setState({
                    invoiceList: response.data.Invoices.map((item) => ({
                        id: item.InvoiceID.slice(item.InvoiceID.length - 6),
                        date: moment(item.date).format('ddd, D MMM YYYY'),
                        type: item.Type,
                        status: item.Status,
                        amount: item.Total,
                        action: (
                            <span className="span-clickable" onClick={() => this.getInvoicePDF(item.InvoiceID)}>
                                View
                            </span>
                        )
                    }))
                });
            }).catch((error) => {
                console.error(error);
            });
    }

    getInvoicePDF = (invoiceId) => {
        invoiceService.getInvoicePDF(invoiceId)
            .then(() => {
                const s3client = new AWS.S3({
                    accessKeyId: config.AWS_S3.ACCESS_KEY,
                    secretAccessKey: config.AWS_S3.SECRET_ACCESS_KEY
                });
                const params = {
                    Bucket: config.AWS_S3.BUCKET,
                    Key: `xero/tmp/${invoiceId}.pdf`
                };
                s3client.getSignedUrl('getObject', params, (err, data) => {
                    window.open(data);
                });
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * @todo Change the Filter selection options
     */
    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="Accounts" />
                    <ContentCard
                        className="mt-62"
                        divider={false}
                        headerTitle="Showing all invoices and rebates"
                        headerBtnText="View more"
                        headerStyle={{ paddingBottom: 0 }}
                    >
                        <CustomTable
                            data={this.state.invoiceList}
                            headers={this.headers}
                            className="accounts-table"
                        />
                    </ContentCard>
                </div>
            </div>
        );
    }
}

export default Accounts;
